import React, { Component } from 'react';

export default class MemberInfo extends Component {

    render () {
        return (
            <div className="col-xs-12 col-md-12 col-lg-12 text-center border-bottom mb-15">
                <h3 className='heading'>{this.props.title}</h3>
                {this.props.subtitle && <h5>{this.props.subtitle}</h5>}
            </div>
        );
    }
}
